import { Button, Dialog } from 'bs-unified-ui';
import { Typography } from '@mui/material';

const ConfirmDialog = ({ title, content, onCancel, onOk, isLoading }) => (
  <Dialog
    title={title}
    maxWidth={400}
    open
    onClose={onCancel}
    renderFooter={
      <Button loading={isLoading} disabled={isLoading} onClick={onOk}>
        Continue
      </Button>
    }
  >
    <Typography variant='fs14'>{content}</Typography>
  </Dialog>
);

export default ConfirmDialog;
